import { Component } from "react";
import { connect } from "react-redux";
import { withRouter } from "../../../../utils/withRouter";
import Loader from "../../../../utils/Loader";
import { ToastContainer } from "react-toastify";
import HeaderWithLogo from "../../../../common_components/header_with_logo";
import AdminDrawer from "../../../../common_components/admin_module_drawer";
import { getExhBadeApplications_action, updateExhBadgeApproval_action } from "../../../../actions/admin_module_action/manual_forms_admin_action/exhBadges_approval_action/exhBadge_approval_action";
import { toastError, toastSuccess } from "../../../../utils/constants";
import { data } from "jquery";
import CommonModal from "../../../../utils/CommonModal";


class ExhibitorBadgesApproval extends Component {
  // Initialized Constructor
  constructor(props) {
    super(props);
    this.state = {
      isLoading: false,
      CompanyName: "",
      exhBadgeApplicationList: [],
      isViewModalOpen: false,
      selectedComponent: null,
      selectedId: null,
      UnPaid: false,
      isSelectAll: false,
    };
    this.getExhBadgesApplications = this.getExhBadgesApplications.bind(this);
    this.onCheckedAppliactions = this.onCheckedAppliactions.bind(this);
    this.onRemarkEnter = this.onRemarkEnter.bind(this);
    this.updateExhbadgeApproval = this.updateExhbadgeApproval.bind(this);
    this.onViewClick = this.onViewClick.bind(this);
  }

  // On Component Load
  componentDidMount() {
    console.log("ssssssssssssss", this.props)
    this.props.location.state != null &&
      this.props.location.state.companyName != "" &&
      this.getExhBadgesApplications(this.props.location.state.companyName);

    this.setState({
      CompanyName:
        this.props.location.state != null && this.props.location.state.companyName
          ? this.props.location.state.companyName
          : "",
    });
  }

  // Get Exh Badges Appliactions
  getExhBadgesApplications(companyname) {
    this.setState({ isLoading: true });
    this.props
      .getExhBadeApplications_action(companyname)
      .then((data) => {
        if (data.error != 1) {
          console.log("getExhBadgesApplications Data", data.data);
          data.data.map((item) => {
            item.isSelected = false;
            item.isReadOnly = true;
          });
          this.setState({
            exhBadgeApplicationList: data.data,
            isLoading: false,
          });
        } else {
          this.setState({ isLoading: false });
          toastError(data.msg);
        }
      })
      .catch((err) => {
        console.log(err);
      });
  }

  // On Check Exh Badge Applications
  onCheckedAppliactions(e) {
    const { exhBadgeApplicationList } = this.state;
    var checked = e.target.checked;
    var id = e.target.value;

    exhBadgeApplicationList.length > 0 &&
      exhBadgeApplicationList.map((data) => {
        if (checked) {
          if (id == data.ExhBadgesFormID) {
            data.isSelected = true;
            data.isReadOnly = false;
          }
        } else {
          if (id == data.ExhBadgesFormID) {
            data.isSelected = false;
            data.isReadOnly = true;
          }
        }
      });
    console.log("09000909090", exhBadgeApplicationList);
    this.setState({});
  }

  /// On Remark Enter
  onRemarkEnter(e, id) {
    const { exhBadgeApplicationList } = this.state;
    var value = e.target.value;
    var list = [...exhBadgeApplicationList];
    list.length > 0 &&
      list.map((data) => {
        if (data.ExhBadgesFormID == id) {
          data.Remarks = value;
        }
      });
    console.log("0101010100101", list);
    this.setState({ exhBadgeApplicationList: list });
  }

  // On Update Visa Approval
  updateExhbadgeApproval(e, key) {
    const { exhBadgeApplicationList, CompanyName } = this.state;
    var applicationList = exhBadgeApplicationList.filter((item) => item.isSelected == true);
    var list;
    // checked Application List data Preparing to store
    var list = [];
    applicationList.map((data) => {
      var mapData = {
        ExhBadgeFormID: parseInt(data.ExhBadgesFormID),
        Remarks: data.Remarks,
        isPaid: data.isPaidBadge,
      };
      list.push(mapData);
    });
    const isCheckedRemark = list.every((item) => item.Remarks != "" && item.Remarks != null);
    if (list.length > 0) {
      if (key == 2 ? isCheckedRemark : true) {
        this.setState({ isLoading: true });
        this.props
          .updateExhBadgeApproval_action(key == 1 ? true : false, list)
          .then((data) => {
            if (data.error != 1) {
              this.setState({ isLoading: false });
              toastSuccess(
                `Exhibitor Badge Form ${key == 1 ? "Approval" : "Disapproval"} Successfully!`
              );
              setTimeout(() => {
                this.getExhBadgesApplications(CompanyName);
              }, 1000);
            } else {
              this.setState({ isLoading: false });
              toastError(data.msg);
            }
          })
          .catch((err) => {
            console.log(err);
          });
      } else {
        toastError("Please Enter Remark");
      }
    } else {
      toastError("Select Atleast One Application");
    }
  }

  // On View Click
  onViewClick(ServiceName, id, isPaidBadge) {
    this.setState({
      isViewModalOpen: true,
      selectedComponent: ServiceName,
      selectedId: id,
      UnPaid: isPaidBadge == 'Yes' ? 0 : 1,
    });
  }

  render() {
    const { isLoading, exhBadgeApplicationList,isSelectAll } = this.state;
    console.log("edirectoryBadgeAppproval", this.props)
    return (
      <>
        {isLoading ? <Loader></Loader> : null}
        <ToastContainer />
        <HeaderWithLogo />
        <AdminDrawer />
        <div className="with-dr-container">
          <div className="main-container">
            <div className="row m-0">
              <div className="breadcrumb-scroll-fixed">
                <h6 className="mb-0 p-2 text-white">Exhibitor Badge Approval</h6>
              </div>
            </div>
          </div>
          <div className="admin-top-space pt-2">
            <div className="row mb-6 m-0">
              {/* <div className="col-lg-12 mt-2">
                                    <div className="row">
                                        <div className="col-md-4">
                                            <label htmlFor="validationCustom03">Login Name</label>
                                            <input
                                                type="text"
                                                className="form-control"
                                                defaultValue="jindal rectifiers"
                                            />
                                        </div>
                                        <div className="col-md-4">
                                            <label htmlFor="validationCustom03">Badge Quota</label>
                                            <input type="text" className="form-control" />
                                        </div>
                                        <div className="col-md-4">
                                            <label htmlFor="validationCustom03">Balance Quota</label>
                                            <input type="text" className="form-control" />
                                        </div>
                                    </div>
                                </div> */}
              <div className="table-responsive">
                <table className="table border text-nowrap text-md-nowrap table-bordered mb-0 ">
                  <thead>
                    <tr>
                      <th className="text-center">Sr.No</th>
                      <th className="text-center">
                        <input
                          type="checkbox"
                          checked={isSelectAll}
                          value={isSelectAll}
                          onChange={(e) => {
                            const checked = e.target.checked;
                            this.setState({
                              isSelectAll: checked,
                              exhBadgeApplicationList: exhBadgeApplicationList.map((item) => ({
                                ...item,
                                isSelected:
                                  item.Status !== "Approved" && item.Status !== "Disapproved"
                                    ? checked
                                    : item.isSelected,
                              })),
                            });
                          }}
                        />
                        Select All</th>
                      {/* <th className="text-center">Vaccine</th> */}
                      <th>Name</th>
                      <th>Is Paid Badge</th>
                      <th className="text-center">Country</th>
                      <th className="text-center">Status</th>
                      <th>Remarks</th>
                      <th>Action</th>
                    </tr>
                  </thead>
                  <tbody>
                    {exhBadgeApplicationList.length > 0 &&
                      exhBadgeApplicationList.map((data, index) => (
                        <tr key={data.ExhBadgesFormID}>
                          <td className="text-center">{index + 1}</td>
                          <td className="text-center">
                            <input
                              type="checkbox"
                              checked={data.isSelected}
                              value={data.ExhBadgesFormID}
                              disabled={data.Status == "Approved" || data.Status == "Disapproved"}
                              onChange={(e) => this.onCheckedAppliactions(e)}
                            />
                          </td>
                          {/* <td className="text-center grid-img">
                                                        <a
                                                            href={data['VaccinationCertifcateFilePath']}
                                                            target="_blank"
                                                            rel="noopener noreferrer"
                                                        >
                                                            <img src={data['VaccinationCertifcateFilePath']} style={{ width: 40 }} />
                                                        </a>
                                                    </td> */}

                          <td>{data.Name}</td>
                          <td>{data.isPaidBadge}</td>
                          <td className="text-center">{data.Country}</td>
                          <td className="text-center">{data.Status}</td>
                          <td>
                            <form>
                              <input
                                type="text"
                                className="form-control"
                                style={{ height: 40 }}
                                disabled={data.isReadOnly}
                                value={data.Remarks}
                                onChange={(e) => this.onRemarkEnter(e, data.ExhBadgesFormID)}
                              />
                            </form>
                          </td>
                          <td className="text-center">
                            <i
                              class="fa fa-eye text-primary"
                              onClick={(e) =>
                                this.onViewClick("Exhibitor Paid Badges", data.ExhBadgesFormID, data.isPaidBadge)
                              }
                            ></i>
                          </td>
                        </tr>
                      ))}
                  </tbody>
                </table>
              </div>
              <div className="main-container mt-2">
                <div className="mt-1 mb-4">
                  <a
                    className="btn btn-aqua"
                    type="submit"
                    onClick={(e) => this.updateExhbadgeApproval(e, 1)}
                  >
                    Approve
                  </a>
                  <a
                    className="btn btn-red m-1"
                    type="submit"
                    onClick={(e) => this.updateExhbadgeApproval(e, 2)}
                  >
                    Reject
                  </a>
                  <a
                    className="btn btn-gray m-1"
                    type="submit"
                    onClick={(e) => window.history.back()}
                  >
                    Back
                  </a>
                </div>
              </div>
            </div>
          </div>
        </div>
        <CommonModal
          isOpen={this.state.isViewModalOpen}
          componentName={this.state.selectedComponent}
          componentProps={{
            is_View: true,
            FormID: this.state.selectedId,
            UnPaid: this.state.UnPaid,
          }}
          onClose={() => this.setState({ isViewModalOpen: false })}
        />
      </>
    );
  }
}
export default withRouter(connect(null, { getExhBadeApplications_action, updateExhBadgeApproval_action })(ExhibitorBadgesApproval))